import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsInt, IsNotEmpty, IsOptional, IsPositive, IsString, Min } from 'class-validator';
import { PromotionExposeGroup } from '../../promotion';
export class GeneratePromocodesRequestDto {
    constructor() {
        this.quotaPerUser = 0;
    }
}
__decorate([
    Expose({ groups: [PromotionExposeGroup.CREATE] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    ApiProperty({
        type: () => String,
        description: 'uuid of promotion of type PROMOCODE that should be used as a configuration pattern',
        example: '08b02b21-2739-45ef-b835-32b0ba5fddf2',
    }),
    __metadata("design:type", String)
], GeneratePromocodesRequestDto.prototype, "promocodeId", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.CREATE] }),
    IsInt({ always: true }),
    IsPositive({ always: true }),
    ApiProperty({ type: () => Number, description: 'Number of promocodes to be generated', example: '10000' }),
    __metadata("design:type", Number)
], GeneratePromocodesRequestDto.prototype, "quota", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.CREATE] }),
    Min(0, { always: true }),
    IsInt({ always: true }),
    IsOptional({ always: true }),
    ApiProperty({ type: () => Number, description: 'Usage quota per user', example: '0 - no limitations; 1 - 1 promocode per user allowed' }),
    __metadata("design:type", Number)
], GeneratePromocodesRequestDto.prototype, "quotaPerUser", void 0);
//# sourceMappingURL=GeneratePromocodesRequestDto.js.map